const sortByAttr = (arr, attribute) => {
  // Copy because .sort() is a mutable operation.
  if (!Array.isArray(attribute)) {
    const arrCopy = arr.slice();
    const sortFn = (i1, i2) => {
      if (i1[attribute] > i2[attribute]) return 1;
      if (i1[attribute] < i2[attribute]) return -1;
      return 0;
    };
    return arrCopy.sort(sortFn);
  } else {
    const arrCopy = arr.slice();
    const sortFn = (i1, i2) => {
      const attributes = attribute;
      let result = null;
      attributes.forEach(({ key, order }) => {
        if (result !== null) return;
        if (i1[key] > i2[key]) result = order === "ascending" ? 1 : -1;
        if (i1[key] < i2[key]) result = order === "ascending" ? -1 : 1;
      });

      if (result === null) {
        result = 0;
      }

      return result;
    };
    return arrCopy.sort(sortFn);
  }
};

export { sortByAttr };
